module.exports = __webpack_public_path__ + "img/ic-coach.a38c96f.svg";